var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-hero" }, [
    _vm.settings.image
      ? _c("div", {
          directives: [
            {
              name: "lazy",
              rawName: "v-lazy:background-image",
              value: _vm.image,
              expression: "image",
              arg: "background-image",
            },
          ],
          staticClass: "page-hero__hero-image lazyload image--fade-in",
        })
      : _c(
          "div",
          {
            staticClass:
              "page-hero__hero-image page-hero__hero-image--placeholder",
          },
          [_vm._t("svg")],
          2
        ),
    _c("div", { staticClass: "page-hero__information-container container" }, [
      _c("div", { staticClass: "page-hero__information" }, [
        _vm.settings.preHeading
          ? _c("p", { staticClass: "page-hero__pre-heading" }, [
              _vm._v(_vm._s(_vm.settings.preHeading)),
            ])
          : _vm._e(),
        _vm.settings.heading
          ? _c("h1", { staticClass: "page-hero__title h1" }, [
              _vm._v(_vm._s(_vm.settings.heading)),
            ])
          : _vm._e(),
        _c("div", {
          staticClass: "page-hero__description",
          domProps: { innerHTML: _vm._s(_vm.description) },
        }),
        _vm.settings.description.length > _vm.charLimit
          ? _c(
              "button",
              {
                staticClass:
                  "button button--icon button--flex page-hero__read-more",
                attrs: { type: "button" },
                on: { click: _vm.toggleDescription },
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.readMoreString))]),
                _c("icon", { attrs: { name: _vm.readMoreIcon, size: "12px" } }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm.divider ? _c("hr", { staticClass: "page-hero__divider" }) : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }